import React from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'
import { useConflictRolePermissions } from 'api/hooks/use-conflict-role-permissions'
import { getScoreDelta } from 'duties/score'
import { InternalConflict } from 'shared/badges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder } from '@fortawesome/free-solid-svg-icons'

function ConflictDetailsModal({ role, show, onHide, conflictId }) {
  const { data: permissions, isSuccess } = useConflictRolePermissions({
    params: {
      conflict_id: conflictId,
      role_id: role?.id,
      conflict_role_id: role?.conflict_role_id
    },
    options: {
      enabled: show
    }
  })

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="h5 w-100 d-flex justify-content-between">
          <span>Conflict Details</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {role ? (
          <>
            <Card>
              <Card.Body>
                <Row>
                  <Col>
                    <strong className="mr-2">Role Score Impact:</strong>
                    <span className="mr-4 text-lg px-1 py-1 text-danger rounded-lg ">
                      +{' '}
                      {role.is_internal &&
                        getScoreDelta(
                          role.role_score,
                          role.raw_score_impact
                        ).toFixed(1)}
                      {!role.is_internal &&
                        (
                          getScoreDelta(
                            role.role_score,
                            role.raw_score_impact
                          ) +
                          getScoreDelta(
                            role.conflict_role_score,
                            role.raw_score_impact
                          )
                        ).toFixed(1)}
                    </span>
                  </Col>
                  <Col>
                    <strong className="mr-2">Internal:</strong>{' '}
                    {role.is_internal ? (
                      <InternalConflict textDisplay="Yes" count={1} />
                    ) : (
                      'No'
                    )}
                  </Col>
                  <Col>
                    <strong className="mr-2">User Count:</strong>{' '}
                    {role.employee_count}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Row className="mt-4">
              <Col>
                <Table size="sm" bordered>
                  <thead className="table-light">
                    <tr>
                      <th>
                        <a
                          href={`/roles/${role.id}`}
                          target="_blank"
                          rel="noreferrer"
                          className="fw-normal"
                        >
                          {role.role_name}
                        </a>
                      </th>

                      <th>
                        <a
                          href={`/roles/${role.conflict_role_id}`}
                          target="_blank"
                          rel="noreferrer"
                          className="fw-normal"
                        >
                          {role.conflict_role_name}
                        </a>
                      </th>
                    </tr>
                    <tr>
                      <th>Permission</th>
                      <th>Conflicting Permission</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isSuccess &&
                      permissions.data.map((permission) => (
                        <tr>
                          <td>
                            <FontAwesomeIcon
                              icon={faFolder}
                              className="me-2 text-muted"
                            />
                            {permission.permission_category_caption}:{' '}
                            {permission.permission_name} <br />
                            <div className="text-muted">
                              ({permission.permission_code})
                            </div>
                          </td>
                          <td>
                            <FontAwesomeIcon
                              icon={faFolder}
                              className="me-2 text-muted"
                            />
                            {permission.conflict_permission_category_caption}:{' '}
                            {permission.conflict_permission_name} <br />
                            <div className="text-muted">
                              ({permission.conflict_permission_code})
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConflictDetailsModal
